import { PainelChamadasRootView } from 'view/chamada-painel/PainelChamadasRootView'

export const ChamadaPainelApp = () => {
  return <PainelChamadasRootView />
}
